<template>
    <el-dialog class="key-data--detail-export" title="明细导出" :visible.sync="visible" :close-on-click-modal="false" :before-close="close" width="500px">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
            <el-form-item label="供应商类型">
                <div>物流供应商</div>
            </el-form-item>
            <el-form-item label="涉外业务类型" prop="isOverseas">
                <MSelect :value="form.isOverseas" :filterable="true" :optionNum="'SRM_IS_OVERSEAS'" @input="handleSelect($event, 'isOverseas')"></MSelect>
            </el-form-item>
            <el-form-item label="业务类型" prop="businessType">
                <MSelect :value="form.businessType" :filterable="true" :optionNum="'SRM_BUSYNESS_TYPE_BACKGROUND'" @input="handleSelect($event, 'businessType')"></MSelect>
            </el-form-item>
            <el-form-item label="主体性质" prop="propertyNature">
                <MSelect :value="form.propertyNature" :filterable="true" :optionNum="'SYS_SUPPLIERS_PROPERTY'" @input="handleSelect($event, 'propertyNature')"></MSelect>
            </el-form-item>
            <el-form-item label="供应商状态" prop="supplierStatus">
                <MSelect :value="form.supplierStatus" :filterable="true" :multiple="true" :optionNum="'SYS_SUPPLIERS_STATUS'" @input="handleSelect($event, 'supplierStatus')"></MSelect>
            </el-form-item>
            <el-form-item label="承运商类别" prop="transType">
                <MSelect :value="form.transType" :filterable="true" :multiple="true" :optionNum="'SRM_SHIPPER_TYPE'" @input="handleSelect($event, 'transType')"></MSelect>
            </el-form-item>
            <el-form-item label="业务类型状态" prop="businessTypeStatus">
                <MSelect :value="form.businessTypeStatus" :filterable="true" :multiple="true" :optionNum="'SYS_SUPPLIER_SERVICES_STATUS'" @input="handleSelect($event, 'businessTypeStatus')"></MSelect>
            </el-form-item>
            <el-form-item label="时间范围" prop="timeRange">
                <el-date-picker value-format="yyyy-MM-dd" v-model="form.timeRange" type="daterange"></el-date-picker>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm" :loading="loading">导出</el-button>
        </span>
    </el-dialog>
</template>
<script>
import dayjs from 'dayjs';
import { exportSupplierDetailInfo } from '../../../../api/register/supplierList.js';
import MSelect from '@/components/lots/otpSelect2/index';

const INIT_FORM = {
    isOverseas: null,
    businessType: null,
    propertyNature: null,
    supplierStatus: [],
    transType: [],
    businessTypeStatus: [],
    timeRange: [],
    startTime: null,
    endTime: null
};

const timeRangeValidator = (rule, value, callback) => {
    const MONTHS = 1;
    if (value && dayjs(value[1]).subtract(MONTHS, 'month').add(1, 'day') > dayjs(value[0])) {
        callback(new Error(`导出数据超过${MONTHS}个月，请重新选择时间范围`));
    } else { callback(); }
};

export default {
    components: { MSelect },
    props: { },
    data() {
        return {
            loading: false,
            visible: false,
            form: { ...INIT_FORM },
            rules: {
                businessType: [{ required: true, message: '请选择业务类型', trigger: ['blur', 'change'] }],
                timeRange: [
                    { required: true, message: '请选择时间范围', trigger: ['blur', 'change'] },
                    { validator: timeRangeValidator, trigger: ['blur', 'change'] }
                ]
            }
        };
    },
    methods: {
        open() {
            this.visible = true;
        },
        close() {
            this.form = { ...INIT_FORM };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.visible = false;
            });
        },
        confirm() {
            this.$refs.form.validate().then(valid => {
                const params = { ...this.form };
                params.startTime = params.timeRange[0];
                params.endTime = params.timeRange[1];
                delete params.timeRange;
                this.loading = true;
                exportSupplierDetailInfo(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data);
                        this.close();
                    }
                }).finally(() => { this.loading = false; });
            });
        },
        handleSelect(val, prop) {
            this.form[prop] = val;
        }
    }
};
</script>
<style lang="less">
.key-data--detail-export {
    .el-range-editor--mini.el-input__inner {
        width: 100%;
    }
}
</style>